module.exports = __webpack_public_path__ + "static/performance-dced57838d83a9d3b171ce4886ccfd58.gif";